import axiosIns from '@/libs/axios'

const ROOT_URL = '/indicators'

export default {
  namespaced: true,
  state: {
    dataList: [],
    active: null,
    backtestResult: null,
    backtestLoading: false,
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    dataList(state) { return state.dataList },
    active(state) { return state.active },
    backtestResult(state) { return state.backtestResult },
    backtestLoading(state) { return state.backtestLoading },
    dataSaveStatus(state) { return state.dataSave },
  },
  mutations: {
    SET_DATA_LIST(state, data) { state.dataList = data },
    SET_ACTIVE(state, data) { state.active = data },
    SET_BACKTEST_RESULT(state, data) { state.backtestResult = data },
    SET_BACKTEST_LOADING(state, val) { state.backtestLoading = val },
    SET_DATA_SAVE(state, data) { state.dataSave = data },
  },
  actions: {
    getDataList({ commit }, params) {
      return axiosIns.post(ROOT_URL, params || {})
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'İndikatör listesi alınamadı.' })
        })
    },
    getActive({ commit }) {
      return axiosIns.get(`${ROOT_URL}/me/active`)
        .then(response => {
          commit('SET_ACTIVE', response.data.data)
        })
        .catch(error => {
          console.error(error)
        })
    },
    activate({ commit, dispatch }, body) {
      return axiosIns.post(`${ROOT_URL}/activate`, body)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: response.data.message || 'Aktifleştirildi.' })
          // Re-fetch active
          dispatch('getActive')
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Aktifleştirme başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
        })
    },
    deactivate({ commit, dispatch }) {
      return axiosIns.post(`${ROOT_URL}/deactivate`, {})
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: response.data.message || 'Pasif yapıldı.' })
          dispatch('getActive')
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'Pasif yapma başarısız.' })
        })
    },
    backtest({ commit }, body) {
      commit('SET_BACKTEST_LOADING', true)
      commit('SET_BACKTEST_RESULT', null)
      return axiosIns.post(`${ROOT_URL}/backtest`, body)
        .then(response => {
          commit('SET_BACKTEST_RESULT', response.data.data)
          commit('SET_BACKTEST_LOADING', false)
        })
        .catch(error => {
          console.error(error)
          commit('SET_BACKTEST_LOADING', false)
          const msg = error?.response?.data?.message || 'Backtest başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
        })
    },
    syncRegistry({ commit, dispatch }) {
      return axiosIns.post(`${ROOT_URL}/sync`, {})
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: `Registry sync: ${response.data.data.upserted}/${response.data.data.total}` })
          dispatch('getDataList')
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'Sync başarısız.' })
        })
    },
  },
}
